import React, {Component} from 'react';
import {dispatch, connect} from 'react-redux';
import {ClipLoader} from 'react-spinners';
import {Grid, Row, Col, Jumbotron} from 'react-bootstrap';
import {Redirect} from 'react-router';
import {HashLink as Link} from 'react-router-hash-link';
import veri_sign from '../logo-verisign.png';
import inituit_logo from '../intuit-logo.png';
import {clearUser} from '../actions/creators';
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import TrustEBrandLogo from "./truste-brand-logo";

require('es6-promise').polyfill();
require('isomorphic-fetch');


class ReviewStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            url: '',
            loading: true,
            modalContent: '',
            show: false
        };


        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.btnTapped = this.btnTapped.bind(this);
        this.myFunction = this.myFunction.bind(this);
    }

    componentDidMount() {
        var url = this.props.serverUrl + '/v1/document-download/fetchDocumentMetaData?intuit_apikey=preprdakyresHjYaHW1MEBflTsUGE3wXYPFbG4AM';
        document.body.style.cursor = 'wait';
        fetch(
            url,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: "POST",
                responseType: 'blob',
                body: JSON.stringify({
                    email: this.props.email,
                    year: this.props.year,
                    planId: this.props.planId,
                    planEin: this.props.planEin,
                    returnStatus: this.props.returnStatus,
                    documentName: this.props.documentName,
                    taxReturnId: this.props.taxReturnId,
                    token: this.props.token,
                    realmId: this.props.realmId
                })
            }
        )
            .then(response => {
                let clone = response.clone();
                if (response.ok) {

                    document.body.style.cursor = 'default';
                    clone.json().then(json => {
                        var i;
                        for (i = 0; i < json.document.length; i++) {
                            var documentName = json.document[i].documentName;
                            this.myFunction(documentName, i + 1);
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
                this.handleShow();
            });


    }

    myFunction(documentName, docId) {
        var temp = document.getElementById("download-button");
        var docName = documentName;
        var id = docId;
        var btn = document.createElement("BUTTON");
        btn.innerHTML = documentName;
        btn.className = "button";
        btn.style.textDecoration = "underline";
        btn.class = "button";
        temp.appendChild(btn);
        btn.onclick = function () {
            this.btnTapped(docName, id);
        }.bind(this);


    }

    async parseResponse(response) {
        var responseText = '';
        var data = await response.text().then(function (data) {
            responseText = data;
            return data;
        });

        if (responseText == "Token mismatch found") {
            this.setState({modalContent: "Token has expired. Kindle login again!", redirectToLogin: true});
        }

        if (response.status == "500" || response.status == "504") {
            this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
        }
        this.handleShow();
        return responseText;
    }

    btnTapped(docName, docId) {
        var url = this.props.serverUrl + '/v1/document-download/returnDocument?intuit_apikey=preprdakyresHjYaHW1MEBflTsUGE3wXYPFbG4AM';
        document.body.style.cursor = 'wait';
        fetch(
            url,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: "POST",
                responseType: 'blob',
                body: JSON.stringify({
                    email: this.props.email,
                    year: this.props.year,
                    planId: this.props.planId,
                    planEin: this.props.planEin,
                    returnStatus: this.props.returnStatus,
                    documentName: this.props.documentName,
                    taxReturnId: this.props.taxReturnId,
                    token: this.props.token,
                    realmId: this.props.realmId,
                    documentName: docName,
                    documentId: docId
                })
            }
        )
            .then(response => {
                let clone = response.clone();
                if (response.ok) {
                    return response.blob();
                } else {
                    document.body.style.cursor = 'default';
                    var responseText = this.parseResponse(clone);
                    return responseText;
                }
            })
            .then(blob => {
                if (blob != "Token mismatch found") {
                    const file = new Blob(
                        [blob],
                        {type: 'application/pdf'});
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        document.body.style.cursor = 'default';
                        window.navigator.msSaveOrOpenBlob(blob, "return.pdf");
                    } else {
                        var objectUrl = URL.createObjectURL(file);
                        window.open(objectUrl);
                        document.body.style.cursor = 'default';
                    }
                }
            })
            .catch(error => {
                this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
                this.handleShow();
            });
    }

    handleShow() {
        this.setState({show: true});
    }

    handleClose() {
        this.setState({show: false});
        if (this.state.redirectToLogin == true) {
            this.props.clearUser(this.state);
        }
    }


    signOut(e) {
        this.props.clearUser(this.state);
    }


    render() {

        if (this.props.login == "false" || this.props.login == false) {
            return (<Redirect to="/sign_in"/>)
        }


        return (

            <div>
                <Grid>
                    <Row>
                        <table className="user-details-table">
                            <tbody>
                            <td className="user-details">

                                <span className="user-details-info"><b>{this.props.userName}</b></span><br/>
                                <span className="user-details-info"><b>{this.props.email}</b></span>

                                <br/>
                                <Link to="/sign_out" onClick={e => this.signOut(e)}><font color="white" size="2"><u>sign
                                    out</u></font></Link>
                            </td>
                            </tbody>
                        </table>

                    </Row>
                    <Jumbotron className="logged-in">
                        <Row>
                            <Col className="divider" sm={3}>
                            </Col>
                            <Col className="divider" sm={6}>
                                <font size="5" color="green"><b>Status:</b></font>
                                <font size="4">   {this.props.returnStatus}</font><br/><br/>
                                <font size="5" color="green"><b>Plan:</b></font><br/><br/>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="right">TAXYEAR:</td>
                                        <td className="left">{this.props.year}</td>
                                    </tr>
                                    <tr>
                                        <td className="right">ID:</td>
                                        <td className="left">{this.props.planId}</td>
                                    </tr>
                                    <tr>
                                        <td className="right">EIN:</td>
                                        <td className="left">{this.props.planEin}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <br/>
                                <font color="#87ceeb" size="3">Please save the PDF locally if you need more than
                                    30 minutes for review.
                                    If the session expires, first review the saved PDF, then sign in again to
                                    submit your response.
                                </font><br/><br/>
                                <font size="5" color="green"><b>Review Documents:</b></font><br/>
                                &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;

                                <div id="download-button">
                                </div>
                            </Col>
                            <Col sm={3}>
                            </Col>
                            <Modal show={this.state.show} onHide={this.handleClose} animation={false}>

                                <Modal.Body>{this.state.modalContent}</Modal.Body>
                                <Modal.Footer>
                                    <div className="col-md-12 text-center">
                                        <Button variant="secondary" bsClass="close-button" onClick={this.handleClose}>
                                            Close
                                        </Button>
                                    </div>

                                </Modal.Footer>
                            </Modal>
                        </Row>
                    </Jumbotron>
                    <Row>
                        <table className="logo-table">
                            <tbody>
                            <td className="left-brand-logo">
                                <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                    Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                              target="_blank"><font color="blue" size="1.75">
                                Privacy</font></a> <br/>
                                <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights
                                    reserved.</font><br/>
                            </td>
                            <td className="right-brand-logo">
                                <TrustEBrandLogo />
                                <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                   target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                            </td>
                            </tbody>
                        </table>
                    </Row>
                </Grid>
            </div>


        );
    }


}

const mapStateToProps = (state) => {

    return {
        userName: state.userName,
        email: state.email,
        login: state.login,
        planEin: state.planEin,
        planId: state.planId,
        year: state.taxYear,
        token: state.token,
        realmId: state.realmId,
        documentName: state.documentName,
        taxReturnId: state.taxReturnId,
        returnStatus: state.returnStatus,
        serverUrl: state.serverUrl,
        documentList: state.documentList
    }

};


const mapDispatchToProps = dispatch => {
    return {
        clearUser: (state) => {
            dispatch(clearUser(state))
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewStatus);
